import {Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';
import { UserService } from '../services/user.service';
import { PublicSigninDialogComponent } from './publicSigninDialog.component';

@Component({
    selector: 'login-button',
    styles: [`
        .unauth-menu-button {
            padding: 8px;
            min-width: 35px;
        }
    `],
    template: `
        <button *ngIf="!currentUser" class="unauth-menu-button" mat-button (click)="login()">Login</button>
    `
})
export class LoginButtonComponent implements OnInit {
    isPublic: boolean;

    constructor(private router: Router,
                private dialog: MatDialog, 
                private tenantService: TenantService, 
                private userService: UserService) {}
    
    ngOnInit(): void {
        this.tenantService.getUnauthTenantInfo().subscribe(tenant => this.isPublic = tenant.settings.publicTopics === 'true');
    }

    get currentUser() {
        return this.userService.getCurrentUser();
    }

    login() {
        if (this.isPublic) {
            this.dialog.open(PublicSigninDialogComponent, { data: { isExisting: true }});
        } else {
            this.router.navigate(['/login'], { queryParams: { 'originator': this.router.url }});
        }
    };
}